export default "__VITE_ASSET__DnlGG1Sd__"